import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoriecorpoComponent } from './categoriecorpo.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatChipsModule, MatTableModule, MatPaginatorModule, MatSelectModule, MatListModule, MatDatepickerModule, MatFormFieldModule, MatInputModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { BreadcrumbsModule } from 'src/@fury/shared/breadcrumbs/breadcrumbs.module';
import { FuryCardModule } from 'src/@fury/shared/card/card.module';
import { ListModule } from 'src/@fury/shared/list/list.module';
import { MaterialModule } from 'src/@fury/shared/material-components.module';
import { QuickInfoWidgetModule } from '../dashboard/widgets/quick-info-widget/quick-info-widget.module';
import { AddComponent } from './add/add.component';
import { UpdateComponent } from './update/update.component';
import { ShowComponent } from './show/show.component';

@NgModule({
  declarations: [CategoriecorpoComponent, AddComponent, UpdateComponent, ShowComponent],
  entryComponents: [AddComponent, UpdateComponent , ShowComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatChipsModule,
    ListModule,
    MatTableModule,
    MatPaginatorModule,
    MatSelectModule,
    MatListModule,
    MatChipsModule,
    MaterialModule,
    BreadcrumbsModule,
    NgxDatatableModule,
    FuryCardModule,
    MatChipsModule,
    QuickInfoWidgetModule,
    MatDatepickerModule,
    MatFormFieldModule,
    FurySharedModule,
    MatInputModule,
    FormsModule,
    BrowserAnimationsModule
  ]
})
export class CategoriecorpoModule { }
